/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LocationUsageRow } from './LocationUsageRow';
import {
    LocationUsageRowFromJSON,
    LocationUsageRowFromJSONTyped,
    LocationUsageRowToJSON,
    LocationUsageRowToJSONTyped,
} from './LocationUsageRow';

/**
 * 
 * @export
 * @interface WidgetDataLocationUsageWidgetData
 */
export interface WidgetDataLocationUsageWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataLocationUsageWidgetData
     */
    $type?: WidgetDataLocationUsageWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<LocationUsageRow>}
     * @memberof WidgetDataLocationUsageWidgetData
     */
    items: Array<LocationUsageRow>;
}


/**
 * @export
 */
export const WidgetDataLocationUsageWidgetDataTypeEnum = {
    LocationUsage: 'location-usage'
} as const;
export type WidgetDataLocationUsageWidgetDataTypeEnum = typeof WidgetDataLocationUsageWidgetDataTypeEnum[keyof typeof WidgetDataLocationUsageWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataLocationUsageWidgetData interface.
 */
export function instanceOfWidgetDataLocationUsageWidgetData(value: object): value is WidgetDataLocationUsageWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataLocationUsageWidgetDataFromJSON(json: any): WidgetDataLocationUsageWidgetData {
    return WidgetDataLocationUsageWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataLocationUsageWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataLocationUsageWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(LocationUsageRowFromJSON)),
    };
}

export function WidgetDataLocationUsageWidgetDataToJSON(json: any): WidgetDataLocationUsageWidgetData {
    return WidgetDataLocationUsageWidgetDataToJSONTyped(json, false);
}

export function WidgetDataLocationUsageWidgetDataToJSONTyped(value?: WidgetDataLocationUsageWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(LocationUsageRowToJSON)),
    };
}

